import { Expose } from 'class-transformer'

export default class LeadFormError {
  first_name: string[] = []
  last_name: string[] = []
  email: string[] = []
  phone: string[] = []
  practice_name: string[] = []
  parent_company: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}
